/**
 * The reader's address for a filing, opened at a cited passage when one is given.
 *
 * Each part is included only when known: the reader treats any `highlight` as a citation,
 * and `end` only qualifies a `highlight`.
 *
 * @param accession The filing's accession number.
 * @param cite The document the offsets belong to and the absolute character offsets of the
 *   cited span, each optional.
 * @returns A path under `/filings/` for a router link.
 */
export function filingHref(
  accession: string,
  cite: { documentId?: string | null; charStart?: number | null; charEnd?: number | null } = {},
): string {
  const params = new URLSearchParams();
  if (cite.documentId) params.set("doc", cite.documentId);
  if (cite.charStart !== null && cite.charStart !== undefined) {
    params.set("highlight", String(cite.charStart));
    if (cite.charEnd !== null && cite.charEnd !== undefined) params.set("end", String(cite.charEnd));
  }
  const query = params.toString();
  return `/filings/${accession}${query ? `?${query}` : ""}`;
}
